import {Autocomplete, Drawer, Stack, TextField, Typography} from "@mui/material";
import React from "react";
import {addBusiness, addPricing, bus, Business, getValidPositiveNumber, Industry, isValidPositiveNumber, pri, Pricing, Product, qua, uni} from "../../../firebase/index.js";
import APXActionButtons from "../../../reusables/APXActionButtons.jsx";
import type {BSLProps} from "../../../reusables/js/APXBottomSheetLayoutUtils.js";
import useBottomSheet from "../../../reusables/js/APXBottomSheetLayoutUtils.js";
import {hideNumberSpinner} from "../../../reusables/js/APXCrucialStyles.js";


export type AddNewPricingBSLProps = { i: Industry, p: Product, ps: Pricing[], bs: Business[] } & BSLProps;


export default function AddNewPricingBSL({uid, onClose, i, p, ps, bs}: AddNewPricingBSLProps) {
	  
	  const industry: Industry = i;
	  const product: Product = p;
	  const existingPricings: Pricing[] = ps;
	  const existingBusinesses: Business[] = bs;
	  
	  const {isOpen, handleClose} = useBottomSheet({initialState: true, onClose});
	  
	  const [disablePositiveByDefault, setDisablePositiveByDefault] = React.useState(true);
	  
	  const [businessName, setBusinessName] = React.useState("");
	  
	  const [price, setPrice] = React.useState(0);
	  const [quantity, setQuantity] = React.useState(0);
	  const [unit, setUnit] = React.useState("");
	  
	  React.useEffect(() => {
			 setDisablePositiveByDefault(/*FALSY->*/ !!!businessName.trim() || /*FALSY->*/ !!!unit.trim() ||
						/*NOT->*/ !isValidPositiveNumber(price) || /*NOT->*/ !isValidPositiveNumber(quantity) ||
						existingPricings.some((value) => value.businessName === businessName.trim()));
	  }, [businessName, price, quantity, unit]);
	  
	  const handleCancel = () => {
			 setBusinessName("");
			 setPrice(0);
			 setQuantity(0);
			 setUnit("");
			 onClose();
	  };
	  
	  const handleAdd = () => {
			 const industryKey = industry.industryKey;
			 const business = new Business(businessName.trim());
			 if (/*NOT->*/ !existingBusinesses.some((value) => value.businessName === businessName.trim())) {
					addBusiness(uid, industryKey, business.getKey(), business);
			 }
			 const pricing = new Pricing(
						product.getKey(), business.getKey(),
						product.productName, product.productVariantName, business.businessName,
						price, quantity, unit.trim()
			 );
			 addPricing(uid, industryKey, pricing.getKey(), pricing);
			 handleCancel();
	  };
	  
	  return (
				 <Drawer anchor="bottom" open={isOpen} onClose={handleClose} variant="temporary">
						<Stack spacing={2} p={2}>
							  <Typography variant="h6">{product.productName} {product.productVariantName}</Typography>
							  <Stack direction={"row"} spacing={2}>
									 <Autocomplete
												options={existingBusinesses.map((value) => value.businessName).filter((value, index, self) => self.indexOf(value) === index).filter((value) => /*NOT->*/ !existingPricings.some((pricing) => pricing.businessName === value))}
												fullWidth
												freeSolo
												clearOnEscape={false}
												disableClearable={true}
												renderInput={
													  (params) =>
																 <TextField {...params} label={`${bus} Name`} variant="outlined" fullWidth required
																				inputProps={{...params.inputProps, readOnly: false}}
																 />
												}
												value={businessName}
												onInputChange={(e, newValue) => setBusinessName(newValue)}
									 />
							  </Stack>
							  
							  <Stack direction={{xs: "column", sm: "row"}} spacing={2}>
									 <TextField label={pri} variant="outlined" fullWidth required type="number" InputProps={hideNumberSpinner}
													value={price} onChange={(e) => setPrice(getValidPositiveNumber(e.target.value))}
									 />
									 <TextField label={qua} variant="outlined" fullWidth required type="number" InputProps={hideNumberSpinner}
													value={quantity} onChange={(e) => setQuantity(getValidPositiveNumber(e.target.value))}
									 />
									 <Autocomplete options={Object.values(industry.industryUnits)}
														fullWidth
														clearOnEscape={false}
														disableClearable={true}
														renderInput={
															  (params) =>
																		 <TextField {...params} label={uni} variant="outlined" fullWidth required
																						inputProps={{...params.inputProps, readOnly: true}}
																		 />
														}
														value={unit}
														onChange={(e, newValue: string) => setUnit(newValue)}
									 />
							  </Stack>
							  
							  
							  <APXActionButtons onCancel={handleCancel}
													  onAdd={handleAdd}
													  disablePositiveByDefault={disablePositiveByDefault}
							  />
						</Stack>
				 </Drawer>
	  );
}
